import { create } from 'zustand';

const STORAGE_KEY = 'avne-chen-cart';

// Service types
export const SERVICE_TYPES = {
  OBITUARY: 'obituary',
  TOMBSTONE: 'tombstone',
  SCHEDULE_RABBI: 'schedule_rabbi',
  REFURBISH: 'refurbish',
};

// Load from localStorage
const loadFromStorage = () => {
  if (typeof window === 'undefined') return [];
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error loading cart from storage:', error);
    return [];
  }
};

// Save to localStorage
const saveToStorage = (items) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch (error) {
    console.error('Error saving cart to storage:', error);
  }
};

const useCartStore = create((set, get) => {
  // Initialize with stored items
  const initialItems = loadFromStorage();
  
  return {
    items: initialItems,
    
    addItem: (item) => {
      const items = get().items;
      // Check if item already exists (same service type and data)
      const existingIndex = items.findIndex(
        (i) => i.serviceType === item.serviceType && 
        JSON.stringify(i.data) === JSON.stringify(item.data)
      );
      
      let updatedItems;
      if (existingIndex >= 0) {
        // Update quantity if same item
        updatedItems = [...items];
        updatedItems[existingIndex] = {
          ...updatedItems[existingIndex],
          quantity: updatedItems[existingIndex].quantity + (item.quantity || 1),
        };
      } else {
        // Add new item
        const newItem = {
          id: Date.now().toString(),
          serviceType: item.serviceType,
          data: item.data || {},
          quantity: item.quantity || 1,
          addedAt: new Date().toISOString(),
        };
        updatedItems = [...items, newItem];
      }
      
      set({ items: updatedItems });
      saveToStorage(updatedItems);
    },
    
    removeItem: (itemId) => {
      const updatedItems = get().items.filter((item) => item.id !== itemId);
      set({ items: updatedItems });
      saveToStorage(updatedItems);
    },
    
    updateItemQuantity: (itemId, quantity) => {
      if (quantity <= 0) {
        get().removeItem(itemId);
        return;
      }
      const items = get().items.map((item) =>
        item.id === itemId ? { ...item, quantity } : item
      );
      set({ items });
      saveToStorage(items);
    },
    
    updateItem: (itemId, data) => {
      const items = get().items.map((item) =>
        item.id === itemId ? { ...item, data: { ...item.data, ...data } } : item
      );
      set({ items });
      saveToStorage(items);
    },
    
    getItemById: (itemId) => {
      return get().items.find((item) => item.id === itemId) || null;
    },
    
    clearCart: () => {
      set({ items: [] });
      saveToStorage([]);
    },
    
    getItemCount: () => {
      return get().items.reduce((total, item) => total + item.quantity, 0);
    },
  };
});

export default useCartStore;

